import React from 'react';
import SpinnerCrimp from 'src/pages/components/utilities/SpinnerCrimp';
var selfStyles = require('./styles.scss');
var CardJoinSpinner = function () { return (React.createElement("div", { className: selfStyles.wrapper },
    React.createElement(SpinnerCrimp, null))); };
export default CardJoinSpinner;



//////////////////
// WEBPACK FOOTER
// ./src/pages/PageWelcome/CardJoin/CardJoinSpinner.tsx
// module id = 841
// module chunks = 0